import * as Yup from 'yup';

const formValidationSchema = Yup.object().shape({
  dbaName: Yup.string(),
  addressLabel: Yup.string().max(255, 'Max 255 characters'),
  address: Yup.object().shape({
    address_ln_1: Yup.string(),
    address_ln_2: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    zip: Yup.string()
  }),
  locations: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().trim().required('Label is required').max(255, 'Max 255 characters'),
      address: Yup.object().shape({
        address_ln_1: Yup.string(),
        address_ln_2: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        zip: Yup.string()
      })
    })
  ),
  stickyNotesAlert: Yup.boolean(),
  requireInvoiceReview: Yup.boolean(),
  surchargeEnabled: Yup.boolean(),
  surchargeAmount: Yup.number().min(0).max(600),
  batchTime: Yup.string()
});

export default formValidationSchema;
